/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_ForcedInputs */

const en_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forced`)
};

const fr_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force`)
};

const de_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gezwungen`)
};

const it_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costretto`)
};

const ru_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принужденный`)
};

const es_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forzado`)
};

const zh_cn2_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`被迫`)
};

const ja_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制された`)
};

const hi_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मजबूर`)
};

const pt_pt2_editor_filter_forced = /** @type {(inputs: Editor_Filter_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forçado`)
};

/**
* | output |
* | --- |
* | "Forced" |
*
* @param {Editor_Filter_ForcedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_forced = /** @type {((inputs?: Editor_Filter_ForcedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_ForcedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_forced(inputs)
	if (locale === "de") return de_editor_filter_forced(inputs)
	if (locale === "it") return it_editor_filter_forced(inputs)
	if (locale === "ru") return ru_editor_filter_forced(inputs)
	if (locale === "es") return es_editor_filter_forced(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_forced(inputs)
	if (locale === "ja") return ja_editor_filter_forced(inputs)
	if (locale === "hi") return hi_editor_filter_forced(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_forced(inputs)
	return en_editor_filter_forced(inputs)
});